import React, { useState, useEffect } from "react";

import { useHistory, useLocation } from "react-router-dom";

import Contract from "../../../../../presentation/pages/register-account/contract";
import { api } from "../../../../../infra/http/remote";
import toastUtils from "../../../../../utils/ToastUtils";

const MakeContract: React.FC = () => {
  const email = localStorage.getItem("username");

  const { pathname } = useLocation();

  const [, registerType] = pathname.split("/");

  const requestType = {
    "cadastro-basico": "developer-basic",
    "cadastrar-empresa": "developer-company",
  };

  const [loading, setLoading] = useState<boolean>(false);

  const history = useHistory();

  const [data, setData] = useState<any>("");

  const handleSubmit = async (): Promise<void> => {
    try {
      setLoading(true);

      await api.post(
        `/public/register/accept-terms/${
          requestType[registerType as keyof typeof requestType]
        }`,
        {
          email,
        }
      );

      toastUtils.showMessage({
        type: "success",
        message: "Salvo com sucesso!",
      });

      setLoading(false);

      history.push(`/${registerType}/4`);
    } catch (error: any) {
      console.error(error);
      toastUtils.showMessage({
        type: "error",
        message: `Erro ao salvar informações:${
          error?.detail || error?.userMessage
        }`,
      });
      setLoading(false);
    }
  };

  useEffect(() => {
    const loadContract = async (): Promise<void> => {
      const term = await api.get("/public/register");
      setData(term?.data || "");
    };

    loadContract();
  }, []);

  const props = {
    loading,
    data,
    handleSubmit,
  };

  return <Contract {...props} />;
};

export default MakeContract;
